export default "__VITE_ASSET__UqwJXB2R__"